module.exports = __webpack_public_path__ + "img/employer_benefit_fraudprotection.627a6c65.jpg";